import { createFileRoute } from '@tanstack/react-router'
import { UserProfilePage } from '../../../../components/UserProfilePage'

export const Route = createFileRoute('/$org/users/$userUid/settings')({
    component: UserSettingsRoute,
})

function UserSettingsRoute() {
    const { org, userUid } = Route.useParams()
    return <UserProfilePage orgCode={org} userUid={userUid} />
}